import { render, staticRenderFns } from "./ExportMarkets.vue?vue&type=template&id=82cad626&"
import script from "./ExportMarkets.vue?vue&type=script&lang=ts&"
export * from "./ExportMarkets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports